/**
 * AppFooter — tiny universal footer shown on AppLayout (logged-in routes)
 * and Landing/Onboard (logged-out routes). Iter 75.
 *
 * Iter 119 — accepts an already-built `copyrightText` (the caller
 * decides what wording to display) so nothing static about "Physiogenic"
 * lives in this component. Prevents the visual-edits Babel plugin from
 * freezing the copyright text to a compile-time literal that overrides
 * runtime state. `showBrandLegalLink` controls whether the /legal/copyright
 * link renders (only shown on the platform's own pages, not on branded
 * subscribers).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { APP_BUILD_SHORT } from '../lib/version';

export default function AppFooter({ minimal = false, copyrightText = null, showBrandLegalLink = false }) {
  const copyright = copyrightText || '';
  const showLegal = !minimal;
  const showCopyrightLink = !!showBrandLegalLink;
  return (
    <footer className="border-t border-soft mt-12 py-4 px-4 md:px-8 text-[11px] text-fg-muted flex items-center justify-between flex-wrap gap-2 print:hidden"
            data-testid="app-footer">
      <div className="flex items-center gap-3">
        <span data-testid="footer-copyright">{copyright}</span>
        <span className="opacity-60">·</span>
        <span data-testid="footer-version">{APP_BUILD_SHORT}</span>
      </div>
      {showLegal && (
        <div className="flex items-center gap-3">
          <Link to="/legal/privacy" className="hover:text-brand">Privacy</Link>
          <span className="opacity-30">·</span>
          <Link to="/legal/terms" className="hover:text-brand">Terms</Link>
          {showCopyrightLink && (
            <>
              <span className="opacity-30">·</span>
              <Link to="/legal/copyright" className="hover:text-brand" data-testid="footer-copyright-link">Copyright</Link>
            </>
          )}
          <span className="opacity-30">·</span>
          <Link to="/help" className="hover:text-brand">Help</Link>
        </div>
      )}
    </footer>
  );
}
